import { TRANSLATIONS } from './constants.js'

export const language = {
  state: 'en',
  reducers: {
    'survey/set': (state, { survey: { language } }) =>
      TRANSLATIONS[language] ? language : 'en',
  },
}

export const translationCatalogs = {
  state: null,
  reducers: {
    add: (state, { language, catalog }) => ({
      ...state,
      [language]: catalog,
    }),
  },
}

export const secretToken = {
  state: null,
  reducers: {
    'survey/set': (state, { secretToken }) => secretToken,
    'formState/submitted': () => null,
  },
}

export const surveyState = {
  state: 'no-survey',
  reducers: {
    fetching: () => 'fetching',
    fetched: () => 'fetched',
    'survey/set': () => 'fetched',
    invalidToken: () => 'invalid-token',
    fetchFailed: () => 'fetch-failed',
    'formState/submitted': () => 'no-survey',
  },
}

export const formState = {
  state: null,
  reducers: {
    submit: () => 'submitting',
    submitted: () => 'submitted',
  },
}

export const survey = {
  state: {},
  reducers: {
    set: (state, { survey }) => survey,
    'formState/submitted': () => ({}),
  },
}

export const currentQuestionId = {
  state: null,
  reducers: {
    set: (state, { questionId }) => questionId,
    'survey/set': () => ({}),
    'formState/submitted': () => null,
  },
}

export const answersByQuestionId = {
  state: {},
  reducers: {
    setAnswer: (state, { questionId, answer }) => ({
      ...state,
      [questionId]: answer,
    }),
    'survey/set': () => ({}),
    'formState/submitted': () => ({}),
  },
}

export const commentsByQuestionId = {
  state: {},
  reducers: {
    setComment: (state, { questionId, comment }) => ({
      ...state,
      [questionId]: comment,
    }),
    'survey/set': () => ({}),
    'formState/submitted': () => ({}),
  },
}

export const isMenuOpen = {
  state: true,
  reducers: {
    toggle: isMenuOpen => !isMenuOpen,
    'currentQuestionId/set': () => false,
  },
}



// WEBPACK FOOTER //
// ./src/models.js